var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "student_card",
    "data-name": "student card"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.79,6H4.21A2.21,2.21,0,0,0,2,8.21V21.79A2.21,2.21,0,0,0,4.21,24H27.79A2.21,2.21,0,0,0,30,21.79V8.21A2.21,2.21,0,0,0,27.79,6ZM28,21.79a.22.22,0,0,1-.21.21H4.21A.22.22,0,0,1,4,21.79V8.21A.22.22,0,0,1,4.21,8H27.79a.22.22,0,0,1,.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.38,14.8A3,3,0,0,0,13,13a3,3,0,0,0-6,0,3,3,0,0,0,.62,1.8A4,4,0,0,0,6,18v1a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V18A4,4,0,0,0,12.38,14.8ZM9,13a1,1,0,1,1,1,1A1,1,0,0,1,9,13ZM8,18a2,2,0,0,1,4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,14H17a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,13h3a1,1,0,0,0,0-2H17a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,17H17a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentCard);
export default __webpack_public_path__ + "static/media/student_card.a7fbfa7b30fcc1f8a53c27afa780e2a0.svg";
export { ForwardRef as ReactComponent };